import React from "react";
import { IRelease } from "../../interfaces/IRelease";
import { Box, Grid, MenuItem, Typography } from "@mui/material";
import { CustomeTextField } from "../core/CustomeTextField";
import { CustomEditor } from "../core/CustomEditor";
import { RELEASE_STAGES } from "../../interfaces/releaseStages";

export interface IProps {
    currentRelease: IRelease;
    setCurrentRelease: Function;
}

export const ReleaseForm: React.FC<IProps> = ({ currentRelease, setCurrentRelease }) => {
    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={2}>
                    <CustomeTextField
                        attr="is_disabled"
                        label="Freigegeben"
                        object={currentRelease}
                        setObject={setCurrentRelease}
                        type="boolean"
                        required
                        disabled={currentRelease.id < 0}
                    />
                </Grid>
                <Grid item xs={3}>
                    <CustomeTextField
                        attr="release_stage"
                        label="Release-Stufe"
                        object={currentRelease}
                        setObject={setCurrentRelease}
                        type="select"
                        selectString
                        required
                    >
                        {RELEASE_STAGES.map(x =>
                            <MenuItem key={`release_stage-${x.value}`} value={x.value}>
                                {x.title}
                            </MenuItem>
                        )}
                    </CustomeTextField>
                </Grid>
                <Grid item xs={3}>
                    <CustomeTextField
                        attr="releaseAt"
                        label="Veröffentlichung am"
                        object={currentRelease}
                        setObject={setCurrentRelease}
                        type="date"
                        required
                    />
                </Grid>
                <Grid item xs={4}>
                    <CustomeTextField
                        attr="title"
                        label="Version"
                        object={currentRelease}
                        setObject={setCurrentRelease}
                        type="string"
                        required
                    />
                </Grid>
                {(currentRelease.id > 0)  &&
                    <Grid item xs={12}>
                        <Typography variant="subtitle2" sx={{mb: 1}}>
                            Einleitung
                        </Typography>
                        <Box sx={{border: "1px solid rgba(0,0,0,0.23)", borderRadius: 1, p: 1}}>
                            <CustomEditor
                                txt={currentRelease.descriptionHtml || ""}
                                setTxt={(txt:string) => setCurrentRelease({
                                    ...currentRelease,
                                    descriptionHtml: txt
                                })}
                            />
                        </Box>
                    </Grid>
                }
            </Grid>
        </>
    )
}